export default defineNuxtRouteMiddleware(async ({ path, query, hash }) => {
	if (path === "/" || !path.endsWith("/")) {
		return;
	}

	const nextPath = path.replace(/\/+$/, "") || "/";
	const nextRoute = { path: nextPath, query, hash };

	console.info(`Redirecting to ${nextPath}`);
	return navigateTo(nextRoute, { redirectCode: 308 });
});
